import React from 'react';
import { AppButton, Box, ErrorModal, Preloader, Text } from '@common-fe/common-fe';

import { SERVER_ERROR_MODAL_TEXT, SERVER_ERROR_MODAL_TITLE } from '@/common/constants';
import { SuccessModal } from '@/components/elements';

import { EoyReconReturnPlaceholder } from './components/EoyReconReturnPlaceholder';
import { useFinOpsPrefund } from './hooks/useFinOpsPrefund';
import { InfoTable, InvoiceAlertAction } from './components';

export const FinOpsPrefund = () => {
  const {
    formattedData,
    formattedInvoiceTable,
    isLoading,

    formattedPrefundTable,
    isPrefundExist,

    isExportAvailable,
    reportLoading,
    setIsStartDownload,
    isServerError,
    setIsServerError,

    handleRepullPrefund,
    handleRepullReplenishment,
    isPrefundAlertVisible,
    isReplenishmentAlertVisible,
    repullPrefundLoading,
    repullReplenishmentLoading,

    isInvoiceNeedApprove,
    isApproveLoading,
    isSuccess,
    handleApprove,
    handleRefetchStatus,
    amountInput,
    approvedAmountInput,
    isEoyRecon,
    eoyReconPlanName,
  } = useFinOpsPrefund();

  const parsedApprovedAmount = Number(approvedAmountInput) || 0;

  return (
    <>
      <ErrorModal
        testId="Claim_date_server-error"
        visible={isServerError}
        header={SERVER_ERROR_MODAL_TITLE}
        helpText={SERVER_ERROR_MODAL_TEXT}
        buttonText="Close"
        onSetVisible={setIsServerError}
      />
      <SuccessModal
        testId="FinOpsPrefund_approve_success-modal"
        visible={isSuccess}
        header="Invoice has been approved!"
        buttonText="Got it!"
        onSetVisible={handleRefetchStatus}
      />
      <Box width="fit-content" direction="row" align="center" margin={{ bottom: 'spacing24' }}>
        <Text
          size="32px"
          weight={700}
          color="textTitle"
        >
          {formattedData.organizationName}
        </Text>
      </Box>
      <Box background="module" round="small" data-testid="FinOpsPrefund_main_wrapper">
        <InfoTable
          values={formattedInvoiceTable}
          tableTitle="Invoice"
          isLoading={isLoading}
          containerStyles={{ paddingBottom: isPrefundExist ? 0 : '24px' }}
          testId="FinOpsPrefund"
          amountInput={amountInput}
          additionalContent={
            <Box gap="spacing12">
              <InvoiceAlertAction
                isAlertVisible={isPrefundAlertVisible}
                buttonText="Resume"
                description="Please resume to re-start prefund workflow."
                onAction={handleRepullPrefund}
                actionLoading={repullPrefundLoading}
                testId="FinOpsPrefund"
              />

              <InvoiceAlertAction
                isAlertVisible={isReplenishmentAlertVisible}
                buttonText="Repull"
                description="This invoice will no longer attempt to pull funds automatically. To initiate an ACH, please select repull."
                onAction={handleRepullReplenishment}
                actionLoading={repullReplenishmentLoading}
                testId="FinOpsReplenishment"
              />

              <EoyReconReturnPlaceholder
                visible={isInvoiceNeedApprove && isEoyRecon && parsedApprovedAmount !== 0}
                planName={eoyReconPlanName}
                amount={parsedApprovedAmount}
              />
            </Box>
          }
          exportButton={
            isExportAvailable && (
              <AppButton onClick={() => setIsStartDownload(true)} disabled={reportLoading} width="78px">
                {reportLoading ? <Preloader /> : 'Export'}
              </AppButton>
            )
          }
          approveButton={
            isInvoiceNeedApprove && (
              <AppButton onClick={handleApprove} disabled={isApproveLoading} width="91px">
                {reportLoading ? <Preloader /> : 'Approve'}
              </AppButton>
            )
          }
        />
        {isPrefundExist ? (
          <InfoTable
            values={formattedPrefundTable}
            tableTitle="Prefund"
            isLoading={isLoading}
            testId="FinOpsPrefund"
          />
        ) : null}
      </Box>
    </>
  );
};
